<template>
  <!--  -->
  <FsDialog
    v-model="selectProjectPopupShow"
    width="480px"
    title="Please select the project you want to open"
    :close-modal="false"
    class-name="select_project_popup"
  >
    <div class="ctn_box">
      <p class="info" v-if="allProjectOptions?.length">
        The currently displayed project has been deleted, and the related design content can no longer be viewed or
        edited. You can select another project to continue designing, or create a new project to start a new
        configuration.
      </p>
      <p class="info" v-else>
        The currently displayed project has been deleted and the related design content can no longer be viewed or
        edited. You can create a new project to start a new configuration.
      </p>
    </div>
    <CustomSelect
      v-if="allProjectOptions?.length"
      ref="selectProjectRef"
      placeholder="Select project"
      v-model="selectedProject"
      :options="allProjectOptions"
      @change="handleChangeProject"
    >
    </CustomSelect>

    <div class="line_box" v-if="allProjectOptions?.length">
      <div class="line"></div>
      <span>or</span>
      <div class="line"></div>
    </div>

    <FsButton type="gray" width="100%" @click="handleCreateProjectClick">
      <div class="btn_ctn">
        <span class="iconfont icon-a-xinjianadd"></span>
        <span class="text">Create New Project</span>
      </div>
    </FsButton>
  </FsDialog>
</template>

<script setup lang="ts">
import { computed, ref, reactive, onMounted, watch } from 'vue'
import { FsDialog, FsButton, FsTooltip, FsInput } from 'fs-design'
import CustomSelect from '@/layout/components/CustomSelect.vue'

import { useHeaderStore } from '@/store/header'
import { useProjectStore } from '@/store/project'
import { storeToRefs } from 'pinia'
import { getTemplatePopupList, getProjectDetail, createProject } from '@/api/modules/project'
import { useRoute, useRouter } from 'vue-router'
import { trackEvent } from '@/utils/analytics'

const selectedProject = ref<number | null>(null)
const projectStore = useProjectStore()
const headerStore = useHeaderStore()
const router = useRouter()
const route = useRoute()
const { selectProjectPopupShow, allProjectOptions, isInitialized } = storeToRefs(projectStore)
const emits = defineEmits(['update:open', 'action'])
import { useErrorState } from '@/composables/useErrorState'
const { hideError } = useErrorState()
console.log(selectProjectPopupShow, 'selectProjectPopupShow')
const handleCreateProjectClick = () => {
  trackEvent({
    eventCategory: 'dec_project',
    eventAction: 'select',
    eventLabel: 'create_new_project',
  })
  projectStore.hideSelectProjectPopup()
  setTimeout(() => {
    headerStore.showCreateProjectPopup()
  }, 0)
}

const handleChangeProject = (item: any) => {
  console.log('item', item)
  hideError()
  projectStore.setCurrentProjectId(item.value)
  if (item.templateId === 0 && item.isCustomized === 0) {
    headerStore.showSelectTemplatePopup()
  } else {
    projectStore.setCurrentTemplateId(item.templateId)
    projectStore.hideSelectProjectPopup()
    router.push('/design-center')
  }
}

watch(
  [() => route, () => isInitialized],
  ([newRoute, newFlag], [oldRoute, oldFlag]) => {
    console.log(newRoute.name, 'newROute---')
    if (
      !newRoute.path.includes('/project') &&
      !localStorage.getItem('currentProjectId') &&
      newFlag &&
      !(newRoute.name === 'DesignCenter' && newRoute.query.share)
    ) {
      projectStore.showSelectProjectPopup()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="scss">
.fs-dialog {
  .select_project_popup {
    .fs-dialog__closeBox {
      display: none;
    }

    .fs-dialog__content--box {
      padding: 20px;

      .custom_select {
        width: 100%;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.ctn_box {
  margin-bottom: 12px;
  .info {
    @include font14;
    color: #707070;
    margin-bottom: 12px;
  }

  :deep(.custom_select) {
    width: 100%;
  }
}

.line_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 12px 0;

  > div {
    flex: 1 1 auto;
    height: 1px;
    background: #eeeeee;
  }

  > span {
    @include font13;
    color: #707070;
    margin: 0 16px;
  }
}

.btn_ctn {
  display: flex;
  align-items: center;
  color: #0060bf;

  .iconfont {
    display: inline-block;
    width: 16px;
    height: 16px;
    font-size: 16px;
    line-height: 1;
    margin-right: 4px;
  }

  .text {
    color: #0060bf;
    @include font14;
  }
}
</style>
